import { connect } from 'react-redux';
import DuePaymentsConfirmModal from "./DuePaymentsConfirmModal";
import { getTranslation } from "../../../../../reducers/common/localization";
import { getActiveModal, hideModal, MODAL_UNI_DUE_PAYMENT_CONFIRM } from "../../../../../reducers/common/activeModal";
import { fetchPayDuePaymentsForUniversity } from '../../../../../reducers/systemPayments/duePayments';
import { resetSubmitFormData } from '../../../../../reducers/common/submitForm';

const mapStateToProps = state => {
    return {
        isOpen: getActiveModal(state).modalKey === MODAL_UNI_DUE_PAYMENT_CONFIRM,
        translation: getTranslation(state)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onCancel: () => {
            dispatch(hideModal());
            dispatch(resetSubmitFormData());
        },
        onPayDuePayments: (id, data) => {
            dispatch(fetchPayDuePaymentsForUniversity(id, data))
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(DuePaymentsConfirmModal);



// WEBPACK FOOTER //
// ./src/components/paymentManagement/systemPaymentComponent/duePaymentsList/duePaymentsConfirmModal/UniversityDuePaymentsConfirmModal.container.js